<header id="header" class="2.1.3">
  <div class="header-left flex-display">
    <a class="header-left-margin" title="seleziona per tornare alla pagina iniziale di myintranet"
      href="https://myintranet-cdemo.collaudo.regione.veneto.it/myintranet/C_DEMO/admin">
      <img class='myIntrlogo' src="assets/images/logo-myintranet-neg.svg"></a>

    <a class="header-left-margin" aria-label="apri/chiudi menu" href="javascript:void(0)" title="apri/chiudi menu" (click)="toggleMenu()">
      <mat-icon id='menu'>menu</mat-icon>
    </a>
  </div>

  <div class="header-right flex-display">
    <div class="flex-display mR">
      <h6 class="ttw ">Regione del Veneto</h6>
      <mat-form-field appearance="fill" color='accent' class="ente" >
        <mat-label><mat-icon id='person'>person_outline</mat-icon></mat-label>
        <mat-select (valueChange)="setLabelOnChangeValue($event)" [formControl]="selected" style="width: 400px;">
          <mat-option value="1">	<mat-icon style="font-size: large;">account_circle</mat-icon> {{utenteLoggato}}</mat-option>
          <mat-option value="3" *ngIf="isUtenteLoggato">	<mat-icon style="font-size: large;">account_circle</mat-icon> Cambia ruolo/ente </mat-option>
          <mat-option value="2" *ngIf="isUtenteLoggato">
            <b style="color:#ff4081; font-size: small;">
              <mat-icon style="font-size: large;">power_settings_new</mat-icon> LOGOUT
            </b>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</header>

<div id='container'>
  <aside id='sideM'>
    <myp-side-menu *ngIf="menu" [menu]="openCloseMenu.asObservable()" ></myp-side-menu>
  </aside>
  <main id='content' [ngClass]="{'adapter':menu}">
      <div *ngIf="loadService.isLoading | async" class="spinner-style">
        <div class="spinner"></div>
      </div>
        <myp-alerts-center></myp-alerts-center>
        <router-outlet></router-outlet>
  </main>
</div>

<footer>
  <myp-footer [footerLogo]="menu"></myp-footer>
</footer>
